
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro/astrologers",
      function () {
        return require("private-next-pages/astro/astrologers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astro/astrologers"])
      });
    }
  